import { FormOption } from '@/types/forms';
import * as Select from '@radix-ui/react-select';
import clx from 'classnames';

const SelectItem = ({ value, option, style }: { option: FormOption; style?: React.CSSProperties; value: string }) => (
  <div style={style}>
    <Select.Item className="group" value={value}>
      <Select.ItemText>
        <span
          className={clx(
            'flex items-center justify-between gap-2 p-2.5 text-neutral-900 lg-regular',
            'group-hover:bg-neutral-100 clickable outline-0 cursor-pointer group-data-[state=checked]:bg-neutral-50',
            'transition-colors duration-quick ease-out',
          )}
        >
          <span className="flex items-center gap-2 whitespace-nowrap">
            {option.icon && <img alt="" className="h-4" src={option.icon} />}
            {option.label}
          </span>
          <i className="group-data-[state=checked]:visible invisible fa-solid fa-circle-check" />
        </span>
      </Select.ItemText>
    </Select.Item>
  </div>
);

export default SelectItem;
